// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name='AutocompleteTextBox'] {\n}\n\n[name='AutocompleteTextBox_Portal'] {\n  position: absolute;\n  background: 'var(--primary-header-bg)';\n  border-radius: 0 0 3px 3px;\n  box-shadow: 0 15px 30px -10px rgba(0, 0, 0, 0.2);\n  padding: 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
